import { Link } from 'react-router-dom';

const stats = [
  { value: '5', label: '观察栏目' },
  { value: '128+', label: '整理话题' },
  { value: '36 万', label: '月阅读人次' },
];

export default function HeroSection() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="relative h-[540px] w-full md:h-[640px]">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20of%20two%20contrasting%20cultural%20colour%20fields%20colliding%20in%20bold%20textured%20brush%20strokes%20warm%20terracotta%20red%20against%20deep%20olive%20green%20on%20cream%20paper%20background%20dramatic%20tension%20dynamic%20composition%20modern%20art%20poster%20style%20no%20text&width=1600&height=900&seq=meiri-hero-main&orientation=landscape"
          alt="美日文化冲突主题的抽象艺术拼贴背景"
          title="美日吃瓜 - 围观美日文化冲突名场面"
          className="absolute inset-0 h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-950/75 via-primary-950/55 to-primary-950/85"></div>

        <div className="relative z-10 mx-auto flex h-full w-full max-w-5xl flex-col items-center justify-center px-4 text-center">
          <p className="hero-in mb-6 inline-flex items-center gap-2 rounded-full border border-accent-300/40 bg-accent-500/15 px-4 py-1.5 text-xs font-medium tracking-wide text-accent-200 backdrop-blur">
            <i className="ri-eye-line text-base"></i>
            文化冲突观察频道 · 先把两边的话都听完
          </p>
          <h1 className="hero-in-delay-1 font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl md:leading-tight">
            美日吃瓜
            <span className="mt-3 block text-xl font-semibold text-background-100 md:text-3xl">
              围观美日文化冲突名场面
            </span>
          </h1>
          <p className="hero-in-delay-2 mt-6 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
            争议言论、网络骂战、价值观碰撞、政治正确翻车现场，一应俱全。我们不做站队，只把不同立场的说法摆到同一张桌上，看这场热闹里究竟发生了什么。
          </p>
          <div className="hero-in-delay-3 mt-9 flex w-full flex-col items-center justify-center gap-3 sm:flex-row">
            <Link
              to="/topics"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-7 py-3 text-sm font-semibold text-primary-950 transition-colors hover:bg-accent-400 sm:w-auto"
            >
              开始围观
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/category/value-clash"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10 sm:w-auto"
            >
              先看价值观碰撞
            </Link>
          </div>

          <dl className="mt-12 grid w-full max-w-2xl grid-cols-3 gap-4 border-t border-background-50/20 pt-6">
            {stats.map((item) => (
              <div key={item.label} className="flex flex-col-reverse text-center">
                <dt className="mt-1 text-xs text-background-300">{item.label}</dt>
                <dd className="font-heading text-xl font-bold text-accent-300 md:text-2xl">{item.value}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>

      <div className="border-b border-background-200 bg-background-100">
        <div className="mx-auto flex w-full max-w-7xl flex-col gap-3 px-4 py-4 text-center text-xs text-foreground-600 sm:flex-row sm:items-center sm:justify-center sm:gap-6 md:px-6 md:text-sm">
          <span className="flex items-center justify-center gap-2">
            <i className="ri-compass-3-line text-primary-500"></i>
            每期补齐事件背景与双方立场
          </span>
          <span className="hidden text-background-400 sm:block">/</span>
          <span className="flex items-center justify-center gap-2">
            <i className="ri-scales-3-line text-primary-500"></i>
            不预设立场，不扣帽子
          </span>
          <span className="hidden text-background-400 sm:block">/</span>
          <span className="flex items-center justify-center gap-2">
            <i className="ri-book-open-line text-primary-500"></i>
            提供可延伸阅读的语境
          </span>
        </div>
      </div>
    </section>
  );
}